/**
 * @desc 获取sku物流信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.ViewLogisticsSkuResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsSku/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
